import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  age: "26",
  monthlyInvestment: 10000,
  incrementPerYear: "6.5",
  approxReturn: "6.5",
  noOfInvestementYear: "26",
  swpStartYear: "10",
  yearlyWithdraw: 10000,
  yearlyIncrementInWithdrawSwp: "6.5",
  resultSip: "",
  isOpen: false,
  addAmountSIP: false,
  addAmountLUM: false,
  investmentDataSIP: [],
  investmentAmounts: [],
  tempInvestmentAmounts: [],
  sipErrors: null,
  selectedOption: "0-1",
  filterInvestmentData: [],
};

const sipAndSwpSlice = createSlice({
  name: "sipAndSwp",
  initialState: initialState,
  reducers: {
    setAge(state, action) {
      state.age = action.payload;
    },
    setMonthlyInvestment(state, action) {
      state.monthlyInvestment = action.payload;
    },
    setIncrementPerYear(state, action) {
      state.incrementPerYear = action.payload;
    },
    setApproxReturn(state, action) {
      state.approxReturn = action.payload;
    },
    setNoOfInvestementYear(state, action) {
      state.noOfInvestementYear = action.payload;
    },
    setSwpStartYear(state, action) {
      state.swpStartYear = action.payload;
    },
    setYearlyWithdraw(state, action) {
      state.yearlyWithdraw = action.payload;
    },
    setYearlyIncrementInWithdrawSwp(state, action) {
      state.yearlyIncrementInWithdrawSwp = action.payload;
    },
    setResultSip(state, action) {
      state.resultSip = action.payload;
    },
    setIsOpen(state, action) {
      state.isOpen = action.payload;
    },
    setAddAmountSIP(state, action) {
      state.addAmountSIP = action.payload;
    },
    setAddAmountLUM(state, action) {
      state.addAmountLUM = action.payload;
    },
    setInvestmentDataSIP(state, action) {
      state.investmentDataSIP = action.payload;
    },
    setInvestmentAmounts(state, action) {
      state.investmentAmounts = action.payload;
    },
    setTempInvestmentAmounts(state, action) {
      state.tempInvestmentAmounts = action.payload;
    },
    setSipErrors(state, action) {
      state.sipErrors = action.payload;
    },
    setSelectedOption(state, action) {
      state.selectedOption = action.payload;
    },
    setFilterInvestmentData(state, action) {
      state.filterInvestmentData = action.payload;
    },

    setRemoveFields(state) {
      state.age = "26";
      state.monthlyInvestment = 10000;
      state.incrementPerYear = "6.5";
      state.approxReturn = "6.5";
      state.swpStartYear = "10";
      state.yearlyWithdraw = 10000;
      state.yearlyIncrementInWithdrawSwp = "6.5";
      state.filterInvestmentData = [];
      state.investmentDataSIP = [];
      state.sipErrors=null
    },
  },
});

export const {
  setRemoveFields,
  setAge,
  setMonthlyInvestment,
  setIncrementPerYear,
  setApproxReturn,
  setNoOfInvestementYear,
  setSwpStartYear,
  setYearlyWithdraw,
  setYearlyIncrementInWithdrawSwp,
  setResultSip,
  setIsOpen,
  setAddAmountSIP,
  setAddAmountLUM,
  setInvestmentDataSIP,
  setInvestmentAmounts,
  setTempInvestmentAmounts,
  setSipErrors,
  setSelectedOption,
  setFilterInvestmentData,
} = sipAndSwpSlice.actions;
const { reducer } = sipAndSwpSlice;
export default reducer;
